import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import "../Inventory/Inventory.css";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import { IoIosSearch } from "react-icons/io";
import { components } from "react-select";

export const SubOrdersReorder = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refNo, setRefNo] = useState();
  const [receivedData, setReceivedData] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [paymentType, setPaymentType] = useState();
  const [paymentMode, setPaymentMode] = useState();
  const [dropdownProductcode, setDropdownProductCode] = useState();
  // search icon in product code
  const SearchDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <IoIosSearch size={16} color="#92959c" />
      </components.DropdownIndicator>
    );
  };
  // add row of reorder
  const [reorderStockRow, setReorderStockRow] = useState([
    {
      id: Date.now() + Math.random(),
      productCode: "",
      productId: "",
      product: "",
      category: "",
      // uom: "",
      packageSize:"",
      currentStock: "",
      // sellingPrice: "",
      defaultPrice: "",

      qty: "",

      total: "",
    },
  ]);
  // Add stock  new row
  const handleReorderStockRow = () => {
    setReorderStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now() + Math.random(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        productId: "",
        product: "",
        category: "",
        // uom: "",
        packageSize:"",
        currentStock: "",
        // sellingPrice: "",
        defaultPrice: "",

        qty: "",

        total: "",
      },
    ]);
  };

  // Delete add stock row
  const handleDeleteReorderRow = (id) => {
    setReorderStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };
  const totalQty = reorderStockRow.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0,
  );
  const totalValue = reorderStockRow.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );
  // function handleQtyChange(rowId, value) {
  //   const qty = Number(value);

  //   setReorderStockRow((prevRows) =>
  //     prevRows.map((row) =>
  //       row.id === rowId //only update the matching row here  both row.id===rowId is from frontend
  //         ? {
  //             ...row,
  //             qty: qty,
  //             total: qty * Number(row.defaultPrice || 0),
  //           }
  //         : row,
  //     ),
  //   );
  // }
  function handleQtyChange(rowId, value) {
    const qty=value;
    setReorderStockRow((prevRows) =>
      prevRows.map((row) => {
        if (row.id !== rowId) return row;
        return {
          ...row,
          qty: qty,
          total:  Number(qty || 0)* Number(row.defaultPrice || 0),
        };
      }),
    );
  }
  async function fetchProductDetails(rowId, productId) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/inventory/subdistributor/product/${productId}`,
      );
      if (response.data.status === "success" || response.status === 200) {
        const details = response.data.data;

        setReorderStockRow((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId // only update the matching row here  both row.id===rowId is from frontend
              ? {
                  ...row,
                  backendId: details.id,
                  productId: productId,
                  // productCode: productCode,
                  productCode: details.product_code,
                  product: details.product_name ?? "---",
                  category: details.category ?? "---",
                  // uom: details.uom ?? "---",
                  packageSize:details.package_size ?? "---",
                  currentStock: details.current_stock ?? "---",
                  // sellingPrice: details.subdistributor_selling_price || "",
                  defaultPrice: details.default_cost_price ?? "---",
                  qty: row.qty || 1,
                  total: (row.qty || 1) * details.default_cost_price,
                }
              : row,
          ),
        );
        console.log(
          response.data.message || "Product details fetched successfully",
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   reorderStockRow.forEach((row) => {
  //     if (!row.productCode) {
  //       fetchProductDetails(row.id, "pc-01"); // auto-load first option
  //     }
  //   });
  // }, []);

  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "inventory/subdistributor/product-code/",
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  const productCodeOptions = dropdownProductcode?.map((item) => ({
    value: item.prod_id,
    label: item.product_code,
  }));
  const productNameOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.prod_id,
    label: item.product_name,
  }));
  useEffect(() => {
    LoadDropdownProductcode();
  }, []);
  async function handleSave() {
    try {
      setLoading(true);
      const products = reorderStockRow.map((item) => ({
        product_id: item.backendId,
        qty: Number(item.qty) || 0,
        total: Number(item.total) || 0,
        price: Number(item.defaultPrice) || 0,
      }));

      const payload = {
        reference_no: refNo?.trim() || "",
        received_date: receivedData,
        payment_type: paymentType,
        payment_mode: paymentMode,
        additional_notes: additionalNote,
        products: products,
      };
      const response = await axiosInstance.post(
        "inventory/subdistributor/reorder/",
        payload,
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
        setTimeout(() => {
          navigate("/sub-orders");
        }, 300);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/sub-orders" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Self Order</div>
          </div>

          {/* Reference No & Date */}
          <div className="bulkAddGrid">
            <div>
              <label>Reference No.</label>
              <input
                type="text"
                placeholder="Enter Reference No."
                value={refNo}
                onChange={(e) => setRefNo(e.target.value)}
              />
            </div>
            <div>
              {/* <label>Received Date</label> */}
              <label>Date</label>
              <input
                type="date"
                onChange={(e) => setReceivedData(e.target.value)}
                value={receivedData}
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>Payment Type</label>
              <select onChange={(e) => setPaymentType(e.target.value)}>
                <option value={""} disabled selected>
                  Select
                </option>
                <option value="debit">Debit</option>
                <option value="credit">Credit</option>
              </select>
            </div>
            <div>
              <label>Payment Mode</label>
              <select onChange={(e) => setPaymentMode(e.target.value)}>
                <option value={""} disabled selected>
                  Select
                </option>
                <option value="upi">UPI</option>
                <option value="cash">Cash</option>
              </select>
            </div>
          </div>
          {/* Table */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">Category</TableCell>
                    {/* <TableCell align="left">UOM</TableCell> */}
                    <TableCell align="left">Package Size</TableCell>
                    <TableCell align="left">Current Stock</TableCell>
                    {/* <TableCell align="left">Selling Price</TableCell> */}
                    <TableCell align="left">Default Cost Price/Unit</TableCell>
                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Total Price</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reorderStockRow.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      className="dashboardTableBody"
                    >
                      {/* <TableCell align="left">
                        <select
                          className="addModalQtySelect"
                          value={row.productCode}
                          onChange={(e) => {
                            fetchProductDetails(row.id, e.target.value);
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>
                          {dropdownProductcode?.map((drop) => (
                            <option value={drop.product_code}>
                              {drop.product_code}
                            </option>
                          ))}
                        </select>
                      </TableCell> */}
                      <TableCell align="left" style={{ minWidth: "180px" }}>
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productCodeOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.productCode,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(
                              row.id,
                              selected?.value,
                              selected?.label,
                            )
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          width: "200px",
                          minWidth: "200px",
                        }}
                      >
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productNameOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.product,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(row.id, selected?.value)
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                        {/* {row.product || "---"} */}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.category}
                          placeholder="Category"
                        />
                      </span> */}
                        {row.category ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input type="text" value={row.uom} placeholder="UOM" />
                      </span> */}
                        {/* {row.uom ?? "---"} */}
                        {row.packageSize ?? "---"}
                      </TableCell>
                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.currentStock}
                          placeholder="Current Stock"
                        />
                      </span> */}
                        {row.currentStock ?? "---"}
                      </TableCell>
                      <TableCell align="left">
                        {row.defaultPrice ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="number"
                            value={row.qty}
                            placeholder="Qty"
                            onChange={(e) =>
                              handleQtyChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span> */}
                        {row.total ?? "---"}
                      </TableCell>

                      <TableCell align="left">
                        <MdDeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteReorderRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Add Row Button */}
          <div
            className="addRowText"
            onClick={handleReorderStockRow}
            style={{ cursor: "pointer", marginTop: "10px" }}
          >
            + Add Row
          </div>

          {/* Totals */}
          <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Requested Qty:</span>
                <span>{totalQty} nos</span>
              </div>
              <div className="addModalContent">
                <span>Total Price:</span>
                <span>₹{totalValue.toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="bulkAddTextGrid">
            <div>
              <label>Additional Notes</label>
            </div>
            <div>
              <textarea
                placeholder="Type here"
                rows={4}
                value={additionalNote}
                onChange={(e) => setAdditionalNote(e.target.value)}
              ></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "10px" }}
            >
              {/* <button className="addBtnCancel">Cancel</button> */}
              <button className="addBtnSave" onClick={handleSave}>
                {" "}
                Make Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
